<div class="highlighted-topline highlighted-topline--address"
     *ngIf="truncate && topline?.appliedToplineValue">
  <span *ngIf="topline?.appliedToplineValue">
    <full-address *ngIf="!cityStateOnly"
                  [singleLine]="true"
                  [additionalClasses]="isDoNotContact() ? 'color--gray--007' : 'color--gray'"
                  [noLink]="isDoNotContact()"
                  [address]="topline.appliedToplineValue"></full-address>

    <span *ngIf="cityStateOnly">{{topline.appliedToplineValue | cityState}}</span>


    <i class="fas fa-ban color--red ml-0025"
       *ngIf="isDoNotContact()"
       [matTooltip]="'Do Not Contact'"
       [matTooltipPosition]="'left'"></i>

    <i class="far fa-check pair__verified ml-0025"
       *ngIf="topline.appliedToplineValue?.status === 'verified'"
       [matTooltip]="'Confirmed'"
       [matTooltipPosition]="'left'"></i>
  </span>
</div>

<div *ngIf="!truncate"
     class="toplines__pair toplines__pair--address col__ flexAlign--baseline"
     [ngClass]="{'toplines__pair--empty':!topline?.appliedToplineValue}">
  <div class="pair__icon">
    <i class="fal fa-fw fa-map-marker-alt"
       matTooltip="Address"></i>
  </div>
  <div class="pair__content truncate">
    <span *ngIf="topline.appliedToplineValue"
          class="pair__label">Address</span>
    <span *ngIf="!topline.appliedToplineValue"
          (click)="onAddClicked()"
          class="pair__link link link--noline"
          data-test-id="toplineAddAddressLink">Add
      Address</span>
    <span *ngIf="topline.appliedToplineValue"
          data-test-id="toplineAddress"
          class="pair__link">

       <full-address *ngIf="!cityStateOnly"
                    [address]="topline.appliedToplineValue"
                    [noLink]="isDoNotContact()"
                    [additionalClasses]="{ 'color--gray' : isDoNotContact() }"></full-address>

      <span *ngIf="cityStateOnly">{{topline?.appliedToplineValue | cityState}}</span>

      <i class="fas fa-ban color--red ml-0050"
         *ngIf="isDoNotContact()"
         [matTooltip]="'Do not contact'"
         [matTooltipPosition]="'left'"></i>

      <i class="far fa-check pair__verified ml-0050"
         data-test-id="toplineAddressVerfiedCheck"
         *ngIf="topline.appliedToplineValue?.status === 'verified'"
         [matTooltip]="'Confirmed'"
         [matTooltipPosition]="'left'"></i>

      <i class="far fa-times-circle pair__red ml-0050"
         *ngIf="topline.appliedToplineValue?.status === 'bad'"
         [matTooltip]="'Marked as Bad'"
         [matTooltipPosition]="'left'"></i>
    </span>
  </div>
</div>
